export type NpEmailSignupFeedbackProps = {
  heading: string
  message: string
}

export const NpEmailSignupFeedback = ({ heading, message }: NpEmailSignupFeedbackProps) => {
  return (
    <div className="bg-np-green10 mx-auto flex w-full max-w-100 flex-col gap-4 rounded-2xl px-6 py-8 text-center font-light text-balance xl:gap-6 xl:py-10">
      <p className="text-h3-np">{heading}</p>
      <p className="text-lg">{message}</p>
    </div>
  )
}
